import request from 'superagent'
import _ from 'lodash'
import {safeParse} from '@utils/utils'

export function post(callUrl, variables, data, formData) {
	return new Promise((resolve, reject) => {
		let req = request.post(callUrl)
		if(formData){

			// console.log(">>> data : ", data)
			// _.forEach(data, (v,k) => {
			// 	console.log(">>> v, k : ", v, k)
			// 	req.field(k, v)
			// })

			req
			.set('enctype', 'multipart/form-data')
			.send(data)
			.type('form')
			.redirects(1)
			.end((err, res) => {
				if(err){
					console.log(">>> post err : ", err)
					reject(err)
				}
				console.log(">>> res : ", res)
				resolve(res && res.text && safeParse(res.text))
			})
		}else{
			req
			.send({variables : variables, data : data})
			.set('Accept', 'application/json')
			.then(res => resolve(res.text && res.text !== "" ? JSON.parse(res.text) : "")
			, err => {
				console.log(">>> post err : ", err)
				reject(err)
			})
		}
	})
}

export function get(callUrl, variables, data) {
	return new Promise((resolve, reject) => {
		request.get(callUrl)
		.send({variables : variables, data : data})
		.set('Accept', 'application/json')
		.then(res => resolve(res.text && res.text !== "" ? JSON.parse(res.text) : "")
		, err => {
			console.log(">>> post err : ", err)
			reject(err)
		})
	})
}

export function postFile(callUrl, file, data) {
	return new Promise((resolve, reject) => {
		var formData = new FormData()
		
		formData.append('file', file)

		for (var key in data) {
			formData.append(key, data[key])
		}

		return request.post(callUrl)
		.send(formData)
		.then(res => {
			resolve(res.text && res.text !== "" ? JSON.parse(res.text) : "")
		}, err => {
			console.log(">>> post err : ", err)
			reject(err)
		})
	})
}

export function download(callUrl, fileName) {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest()
		xhr.open('GET', callUrl, true)
		xhr.responseType = 'blob'

		xhr.onload = function(event) {
			if (xhr.status !== 200) {
				reject(new Error('Access denied. You do not have permission to access this resource.'));
			} else {
				const blob = xhr.response
				const url = URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = url
				//link.target= "_blank"
				link.download = fileName
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				resolve()
			}
		}

		xhr.onerror = function(event) {
			throw new Error("HTTP error " + xhr.status)
		}

		xhr.send()
	})
}

export function graphql(fetch, query) {
	try {
		return fetch('/graphql', {
			body: JSON.stringify({
				query
			})
		})
		.then(me => {
			return me.json()
			.then(res => {
				if(res.errors)
					throw res.errors

				return res.data || {}
			})
		})
	} catch(error){
		return error
	}
}

/**
 * Fonction pour les requêtes asynchrones avec callbacks
 * @param {string} callUrl - URL de l'endpoint à exécuter
 * @param {Object} variables - Variables à passer
 * @param {Object} data - Données à passer
 * @param {Object} formData - Données de formulaire
 * @param {Object} callbacks - Callbacks pour la gestion des événements
 * @param {Object} options - Options de polling (maxAttempts, interval)
 * @returns {Promise} - Promise qui se résout avec le résultat final
 */
export function postAsync(callUrl, variables, data, formData, callbacks = {}, options = {}) {
	return new Promise((resolve, reject) => {
		// Lancer la requête asynchrone
		request.post('/async/launch')
			.send({
				endpoint: callUrl,
				variables: variables,
				data: data,
				formData: formData
			})
			.set('Accept', 'application/json')
			.then(async (launchRes) => {
				const { uid } = launchRes.body;
				
				// Délai initial pour laisser le temps au job d'être traité
				await new Promise(resolve => setTimeout(resolve, 1000));
				
				// Démarrer le polling avec callbacks et options personnalisées
				const result = await pollForResult(uid, callbacks, options.maxAttempts, options.interval);
				resolve(result);
			})
			.catch(err => {
				console.log(">>> postAsync err : ", err);
				reject(err);
			});
	});
}

/**
 * Fonction pour les requêtes asynchrones multiples avec callbacks unifiés
 * @param {string|Array} callUrls - URL(s) de l'endpoint à exécuter (string ou array)
 * @param {Object|Array} variables - Variables à passer (object ou array)
 * @param {Object|Array} data - Données à passer (object ou array)
 * @param {Object|Array} formData - Données de formulaire (object ou array)
 * @param {Object} callbacks - Callbacks pour la gestion des événements
 * @param {Object} options - Options de polling (maxAttempts, interval, timeout)
 * @returns {Promise} - Promise qui se résout avec le(s) résultat(s) final(aux)
 */
export function postAsyncMultiple(callUrls, variables, data, formData, callbacks = {}, options = {}) {
	// Normaliser les paramètres en tableaux
	const urls = Array.isArray(callUrls) ? callUrls : [callUrls];
	const vars = Array.isArray(variables) ? variables : [variables];
	const datas = Array.isArray(data) ? data : [data];
	const forms = Array.isArray(formData) ? formData : [formData];
	
	// S'assurer que tous les tableaux ont la même longueur
	const maxLength = Math.max(urls.length, vars.length, datas.length, forms.length);
	
	// Compléter les tableaux avec des valeurs par défaut
	const normalizedUrls = urls.length === 1 ? Array(maxLength).fill(urls[0]) : urls;
	const normalizedVars = vars.length === 1 ? Array(maxLength).fill(vars[0]) : vars;
	const normalizedData = datas.length === 1 ? Array(maxLength).fill(datas[0]) : datas;
	const normalizedForms = forms.length === 1 ? Array(maxLength).fill(forms[0]) : forms;
	
	return new Promise(async (resolve, reject) => {
		try {
			// Lancer toutes les requêtes en parallèle
			const promises = normalizedUrls.map((url, index) => 
				postAsync(url, normalizedVars[index], normalizedData[index], normalizedForms[index], {
					// Callbacks individuels pour chaque requête
					onProgress: (progressData) => {
						if (callbacks.onProgress) {
							callbacks.onProgress({
								...progressData,
								requestIndex: index,
								totalRequests: maxLength,
								requestUrl: url
							});
						}
					},
					onSuccess: (result, meta) => {
						if (callbacks.onSuccess) {
							callbacks.onSuccess(result, {
								...meta,
								requestIndex: index,
								totalRequests: maxLength,
								requestUrl: url
							});
						}
					},
					onError: (error, meta) => {
						if (callbacks.onError) {
							callbacks.onError(error, {
								...meta,
								requestIndex: index,
								totalRequests: maxLength,
								requestUrl: url
							});
						}
					},
					...options
				})
			);
			
			// Attendre que toutes les requêtes se terminent
			const results = await Promise.allSettled(promises);
			
			// Séparer les succès et les erreurs
			const successfulResults = [];
			const errors = [];
			
			results.forEach((result, index) => {
				if (result.status === 'fulfilled') {
					successfulResults.push({
						index,
						url: normalizedUrls[index],
						result: result.value
					});
				} else {
					errors.push({
						index,
						url: normalizedUrls[index],
						error: result.reason
					});
				}
			});
			
			// Callback final avec tous les résultats
			if (callbacks.onAllComplete) {
				callbacks.onAllComplete({
					successful: successfulResults,
					errors: errors,
					total: maxLength,
					successCount: successfulResults.length,
					errorCount: errors.length
				});
			}
			
			// Résoudre avec les résultats
			if (errors.length === 0) {
				resolve(successfulResults.map(r => r.result));
			} else if (successfulResults.length === 0) {
				reject(new Error(`Toutes les requêtes ont échoué: ${errors.map(e => e.error.message).join(', ')}`));
			} else {
				// Certaines ont réussi, certaines ont échoué
				resolve({
					successful: successfulResults.map(r => r.result),
					errors: errors,
					partial: true
				});
			}
			
		} catch (error) {
			console.log(">>> postAsyncMultiple err : ", error);
			reject(error);
		}
	});
}

/**
 * Fonction de polling pour récupérer le résultat d'un job asynchrone
 * @param {string} uid - Identifiant unique du job
 * @param {Object} callbacks - Callbacks pour la gestion des événements
 * @param {number} maxAttempts - Nombre maximum de tentatives
 * @param {number} interval - Intervalle entre les tentatives (ms)
 * @returns {Promise} - Promise qui se résout avec le résultat
 */
async function pollForResult(uid, callbacks = {}, maxAttempts = 60, interval = 2000) {
	const { onProgress, onSuccess, onError } = callbacks;
	
	for (let attempt = 0; attempt < maxAttempts; attempt++) {
		try {
			const statusRes = await request.get(`/async/status/${uid}`);
			const { status, progress, message, result, error } = statusRes.body;
			
			// Callback de progression
			if (onProgress) {
				onProgress({ uid, status, progress, message });
			}
			
			// Émettre un événement de progression (pour compatibilité)
			if (window.emitEvent) {
				window.emitEvent("asyncProgress", { uid, status, progress, message });
			}
			
			if (status === 'completed') {
				// Callback de succès
				if (onSuccess) {
					onSuccess(result, { uid, completedAt: statusRes.body.completedAt });
				}
				return result;
			} else if (status === 'failed') {
				// Callback d'erreur
				if (onError) {
					onError(error, { uid, failedAt: statusRes.body.failedAt });
				}
				// Job définitivement échoué - arrêter immédiatement
				// Marquer le job comme traité pour éviter les appels multiples
				return Promise.reject(new Error(error || 'Job échoué'));
			}
			
			// Attendre avant le prochain polling
			await new Promise(resolve => setTimeout(resolve, interval));
		} catch (error) {
			// Si c'est une erreur de job échoué (status: "failed"), on la propage immédiatement
			if (error.message && error.message.includes('Job échoué')) {
				throw error;
			}
			
			// Si c'est une erreur "Endpoint non supporté" au début, c'est normal
			// Le job n'a pas encore été traité par le worker - PAS d'onError
			if (error.message && error.message.includes('Endpoint non supporté') && attempt < 3) {
				await new Promise(resolve => setTimeout(resolve, interval));
				continue;
			}
			
			// Pour les autres erreurs "Endpoint non supporté" après 3 tentatives,
			// c'est probablement une erreur définitive
			if (error.message && error.message.includes('Endpoint non supporté')) {
				throw error;
			}
			
			// Pour les autres erreurs (réseau, timeout, etc.), on continue ou on abandonne
			if (attempt === maxAttempts - 1) {
				// Callback d'erreur en cas de timeout
				if (onError) {
					onError(error.message, { uid, timeout: true });
				}
				throw error;
			}
			await new Promise(resolve => setTimeout(resolve, interval));
		}
	}
	throw new Error('Timeout: Job non terminé dans le délai imparti');
}